/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP server an identity is authorized to reach.
 */
export type AccessibleMCPServer = {
  /**
   * Unique server identifier.
   */
  id: string;
  /**
   * Display name of the server.
   */
  name: string;
  /**
   * Project the server belongs to.
   */
  projectId: string;
  /**
   * Slug of the project the server belongs to.
   */
  projectSlug: string;
  /**
   * URL-safe server slug.
   */
  slug: string;
};

/** @internal */
export const AccessibleMCPServer$inboundSchema: z.ZodMiniType<
  AccessibleMCPServer,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.string(),
    project_id: z.string(),
    project_slug: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "project_id": "projectId",
      "project_slug": "projectSlug",
    });
  }),
);

export function accessibleMCPServerFromJSON(
  jsonString: string,
): SafeParseResult<AccessibleMCPServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessibleMCPServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessibleMCPServer' from JSON`,
  );
}
